module.exports = __webpack_public_path__ + "img/white-mobile.6c06b6d1.png";